export const TRANSACTION_FOR_GOS_SEARCH_FETCH =
  'TRANSACTION_FOR_GOS_SEARCH_FETCH';
